import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from 'react-router-dom';
import {
  Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ResultGrid } from '../../../../../grid/ResultGrid';
import { Column } from '../../../../../grid/Column';
import { DeleteIcon } from '../../../../../icon/DeleteIcon';
import { EditIcon } from '../../../../../icon/EditIcon';
import {
  bulkEditDeposits as bulkEditDepositsAc,
  cancelEdit as cancelEditAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  openEditConfirmation as openEditConfirmationAc,
  startEdit as startEditAc,
} from '../../../../../../redux/tsunamis/deposits/search/depositSearchActions';
import { createInitialForm, formToJson } from '../edit/depositEditModel';
import {
  checkboxCell,
  latLonCell,
  textCell,
} from '../../../../../grid/resultGridCells';
import { TextEditCell } from '../../../../../grid/TextEditCell';
import {
  minColumns,
  sort as defaultSort,
  visibleColumns as defaultColumns,
} from '../../../../../../redux/tsunamis/deposits/search/depositReduxConstants';

const renderEditLink = id => (
  <Link aria-label={`Edit Deposit ${id}`} to={`/view/hazards/tsunami/update-deposit/${id}`} target="_blank" rel="noopener noreferrer">
    <EditIcon />
  </Link>
);

const renderEventLink = (row, content) => {
  const id = row.get('id');
  const numTsunamiEvents = row.get('numTsunamiEvents');

  if (!numTsunamiEvents) {
    return (<div>{content}</div>);
  }

  return (
    <Link aria-label={`Deposit Event ${id}`} to={`/view/hazards/tsunami/deposit-events/${id}`} target="_blank" rel="noopener noreferrer">
      {content}
    </Link>
  );
};

const renderReferenceLink = (id, content) => (
  <Link aria-label={`Reference ${id}`} to={`/view/reference/info/${id}`} target="_blank" rel="noopener noreferrer">
    {content}
  </Link>
);

const handleBeforeUnload = (event) => {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue = 'leaving reference';
};

export const geologicAgeCell = (row, errors, editing) => {
  if (editing) {
    return (<TextEditCell errors={errors} name={`items[${row.get('id')}].geologicAgeId`} />);
  }
  return (<div>{row.get('geologicAge')}</div>);
};

class DepositDataGridUnwraped extends Component {
  constructor(props) {
    super(props);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.focus = this.focus.bind(this);
    this.handleYesClick = this.handleYesClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditToggle = this.handleEditToggle.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.deleteCancel = null;
    this.state = {
      modal: false,
      selectedId: null,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      deleting,
      onDeleteCloseModal,
      saving,
      cancelEditConfirmation,
      errors,
      cancelEdit,
    } = this.props;
    if (!deleting && prevProps.deleting) {
      this.closeModal(() => {
        onDeleteCloseModal();
      });
    }
    if (!saving && prevProps.saving) {
      cancelEditConfirmation();
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
      if (!errors.size) {
        cancelEdit();
        onDeleteCloseModal(); // reload
      }
    }
  }


  openModal(selectedId) {
    this.setState({
      modal: true,
      selectedId,
    });
  }

  closeModal(callback) {
    this.setState({
      modal: false,
      selectedId: null,
    }, callback);
  }

  handleDeleteClick(id) {
    this.openModal(id);
  }

  focus() {
    this.deleteCancel.focus();
  }

  handleYesClick() {
    const { deleteDeposit } = this.props;
    const { selectedId } = this.state;
    deleteDeposit({ id: selectedId });
  }

  handleSubmit(data) {
    const { bulkEditDeposits } = this.props;
    bulkEditDeposits({ data });
  }

  handleEditToggle(edit) {
    const { startEdit, cancelEdit, deposits } = this.props;
    if (edit) {
      const items = {};
      const initialValues = { items };
      deposits.forEach((item) => {
        items[`${item.get('id')}`] = createInitialForm(item).toJS();
      });
      startEdit({ initialValues });
      window.addEventListener('beforeunload', handleBeforeUnload, true);
    } else {
      cancelEdit();
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
    }
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  render() {
    const {
      deposits,
      dataManager,
      sort,
      visibleColumns,
      searchParams,
      deleting,
      editConfirmationOpen,
      saving,
      formData,
      cancelEditConfirmation,
      openEditConfirmation,
      initialFormData,
      initialValues,
      editing,
      errors,
    } = this.props;

    const { modal } = this.state;

    return (
      <div className="haz-data-grid-container">

        <Modal isOpen={modal || deleting} onOpened={this.focus} backdrop="static">
          <ModalHeader>Delete Tsunami Event</ModalHeader>
          <ModalBody>
            {deleting ? 'Deleting...' : 'Are you sure you want to delete the deposit?'}
          </ModalBody>
          <ModalFooter>
            <Button disabled={deleting} color="danger" onClick={this.handleYesClick}>Delete</Button>
            {' '}
            <Button disabled={deleting} color="secondary" innerRef={(ref) => { this.deleteCancel = ref; }} onClick={() => this.closeModal()}>Cancel</Button>
          </ModalFooter>
        </Modal>

        <ResultGrid
          data={deposits}
          sort={sort}
          columnChooser
          visibleColumns={visibleColumns}
          handleColumnsToggle={this.handleToggleColumns}
          download
          downloadPrefix="deposits"
          downloadSearchParams={searchParams}
          edit={dataManager}
          editing={editing}
          handleEditToggle={this.handleEditToggle}
          initialValues={initialValues}
          handleSubmit={this.handleSubmit}
          editConfirmationOpen={editConfirmationOpen}
          hazardName="Deposits"
          saving={saving}
          handleCancel={cancelEditConfirmation}
          formData={formData}
          initialFormData={initialFormData}
          openEditConfirmation={openEditConfirmation}
          formToJson={formToJson}
          defaultColumns={defaultColumns}
          defaultSort={defaultSort}
          minColumns={minColumns}
        >
          {dataManager && (
          <Column alwaysVisible id="del" cell={({ row }) => (<DeleteIcon handleClick={() => this.handleDeleteClick(row.get('id'))} />)} width={30}>
            <DeleteIcon />
          </Column>
          )}
          {dataManager && (
          <Column alwaysVisible id="edit" cell={({ row }) => renderEditLink(row.get('id'))} width={30}>
            <EditIcon />
          </Column>
          )}
          {dataManager && (
          <Column alwaysVisible id="id" width={70} sortable>Id</Column>
          )}
          {dataManager && (
          <Column alwaysVisible id="publish" cell={({ value, row }) => checkboxCell(row, 'publish', value, errors, editing)} width={45} sortable>Publish</Column>
          )}

          <Column id="author" width={300} sortable cell={({ row, value }) => renderReferenceLink(row.get('referenceId'), value)}>Author</Column>
          <Column id="year" width={45} sortable>Year</Column>
          <Column id="publication" width={100} sortable cell={({ value, row }) => textCell(row, 'publicationType', value, errors, editing)}>Publication</Column>
          <Column id="event" width={200} sortable cell={({ row, value }) => renderEventLink(row, value)}>Event</Column>
          <Column id="geologicAgeOrder" width={200} sortable cell={({ row }) => geologicAgeCell(row, errors, editing)}>Geologic Age</Column>
          <Column id="yearBegin" width={70} sortable cell={({ value, row }) => textCell(row, 'yearBegin', value, errors, editing)}>Earliest Year</Column>
          <Column id="yearEnd" width={70} sortable cell={({ value, row }) => textCell(row, 'yearEnd', value, errors, editing)}>Latest Year</Column>
          <Column id="latitude" width={100} sortable cell={({ value, row }) => latLonCell(row, 'latitude', value, errors, editing)}>Latitude</Column>
          <Column id="longitude" width={100} sortable cell={({ value, row }) => latLonCell(row, 'longitude', value, errors, editing)}>Longitude</Column>
          <Column id="locationName" width={200} sortable cell={({ value, row }) => textCell(row, 'locationName', value, errors, editing)}>Location Name</Column>
          <Column id="country" width={170} sortable cell={({ value, row }) => textCell(row, 'country', value, errors, editing)}>Country</Column>
          <Column id="bodyOfWater" width={150} sortable cell={({ value, row }) => textCell(row, 'bodyOfWater', value, errors, editing)}>Body of Water</Column>
          <Column id="description" width={200} cell={({ value, row }) => textCell(row, 'description', value, errors, editing)}>Narrative Description</Column>
          <Column id="environment" width={200} cell={({ value, row }) => textCell(row, 'environment', value, errors, editing)}>Setting During Event</Column>


        </ResultGrid>
      </div>
    );
  }
}

DepositDataGridUnwraped.propTypes = {
  deposits: ImmutablePropTypes.list.isRequired,
  dataManager: PropTypes.bool.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  sortData: PropTypes.func.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  searchParams: PropTypes.string.isRequired,
  deleting: PropTypes.bool.isRequired,
  deleteDeposit: PropTypes.func.isRequired,
  onDeleteCloseModal: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  bulkEditDeposits: PropTypes.func.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  initialFormData: ImmutablePropTypes.map.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
  startEdit: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  initialValues: ImmutablePropTypes.map.isRequired,
};

const mapStateToProps = state => ({
  saving: state.getIn(['depositSearchPage', 'saving']),
  editConfirmationOpen: state.getIn(['depositSearchPage', 'editConfirmationOpen']),
  formData: state.getIn(['depositSearchPage', 'formData']),
  initialFormData: state.getIn(['depositSearchPage', 'initialFormData']),
  errors: state.getIn(['depositSearchPage', 'errors']),
  editing: state.getIn(['depositSearchPage', 'editing']),
  initialValues: state.getIn(['depositSearchPage', 'initialValues']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  bulkEditDeposits: bulkEditDepositsAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  startEdit: startEditAc,
  cancelEdit: cancelEditAc,
}, dispatch);

export const DepositDataGrid = connect(mapStateToProps, mapDispatchToProps)(DepositDataGridUnwraped);
